module.exports = __webpack_public_path__ + "public/images/slider/speaker-2-icon.74b3fb2dd4b90c0880d0aae07bcc0abb.png";